import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Clock, FileWarning, DollarSign, FileText } from 'lucide-react';
const problems = [{
  icon: Clock,
  text: "Te dicen 'vamos bien', pero underwriting todavía tiene condiciones abiertas."
}, {
  icon: AlertTriangle,
  text: 'Tu inspección cae tarde y ya no te da tiempo a negociar.'
}, {
  icon: FileWarning,
  text: 'El appraisal se retrasa y tu contingency se vence igual.'
}, {
  icon: DollarSign,
  text: 'El Closing Disclosure llega con cambios, y todo el mundo se echa la bolita.'
}, {
  icon: FileText,
  text: 'Te mandan HOA docs en un PDF eterno el último día y esperan que firmes tranquila.'
}];
export function ProblemSection() {
  return <section className="py-20 px-4 bg-[#0F1419] text-[#F5F0E8]" data-id="element-235">
      <div className="max-w-4xl mx-auto" data-id="element-236">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-237">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-238">
            Si estás bajo contrato (o por entrar), te voy a decir algo incómodo
            pero útil:
          </h2>
          <p className="text-lg text-[#8B8578] max-w-2xl mx-auto leading-relaxed" data-id="element-239">
            <span className="text-[#F5F0E8] font-bold" data-id="element-240">
              La gente no pierde dinero porque sea tonta.
            </span>{' '}
            Lo pierde porque el proceso está diseñado para moverse rápido… y tú
            no tienes un tablero con fechas, responsables y confirmaciones por
            escrito.
          </p>
        </motion.div>

        <div className="text-center mb-8" data-id="element-241">
          <p className="text-[#D4A843] font-medium uppercase tracking-widest text-sm" data-id="element-242">
            Entonces pasan cosas como:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-243">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`bg-[#1A1F2E] p-6 rounded-xl border border-[#D4A843]/10 hover:border-[#D4A843]/30 transition-colors ${index === 4 ? 'md:col-span-2 md:w-2/3 md:mx-auto' : ''}`} data-id="element-244">
              <div className="flex items-start space-x-4" data-id="element-245">
                <problem.icon className="w-6 h-6 text-[#C75B3A] shrink-0 mt-1" data-id="element-246" />
                <p className="text-[#F5F0E8] font-medium" data-id="element-247">{problem.text}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#C75B3A]/10 border border-[#C75B3A]/30 p-8 rounded-2xl text-center" data-id="element-248">
          <p className="text-xl md:text-2xl font-serif font-bold text-[#F5F0E8]" data-id="element-249">
            Y tú quedas con la peor combinación: <br data-id="element-250" />
            <span className="text-[#C75B3A]" data-id="element-251">
              mucho riesgo + cero lenguaje + deadlines corriendo.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}